import { IPerfilTipoCliente } from "../../../Interfaces/Geral/CadastroEEditaTipoCliente/CadastroEEditaTipoClienteInterface";
import {
    ListarPerfilTipoContaService,
    GetPerfilTipoContaService,
    CadastrarPerfilTipoContaService,
    AtualizarPerfilTipoContaService,
    DeletarPerfilTipoContaService,
} from "../../../Services/Geral/CadastroEEditaTipoCliente/CadastroEEditaTipoClienteService";
import { Controller } from "../../Controller";

export async function ListarPerfilTipoContaController() {
    return Controller(ListarPerfilTipoContaService());
}

export async function GetPerfilTipoContaController(idPerfilTipoConta: number) {
    return Controller(GetPerfilTipoContaService(idPerfilTipoConta));
}

export async function CadastrarPerfilTipoContaController(
    data: IPerfilTipoCliente
) {
    return Controller(CadastrarPerfilTipoContaService(data));
}

export async function AtualizarPerfilTipoContaController(
    data: IPerfilTipoCliente
) {
    return Controller(AtualizarPerfilTipoContaService(data));
}

export async function DeletarPerfilTipoContaController(
    idPerfilTipoConta: number
) {
    return Controller(DeletarPerfilTipoContaService(idPerfilTipoConta));
}
